import { render, staticRenderFns } from "./PopupDashAdmin.vue?vue&type=template&id=e8d5e192"
import script from "./PopupDashAdmin.vue?vue&type=script&lang=js"
export * from "./PopupDashAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports